import { addEventListeners, removeEventListeners } from "../utils/dom";

export default class RadioButtonListCollapse extends HTMLFieldSetElement {

    connectedCallback() {

        addEventListeners(this.radioElements, "change", this.filterItems);

    }

    disconnectedCallback() {

        removeEventListeners(this.radioElements, "change", this.filterItems);

    }

    filterItems = (e) => {
        let selector = "";

        for (const selectedRadio of Array.from(this.radioElements).filter(radio => radio.checked)) {
            const value = selectedRadio.dataset.value || selectedRadio.value;
            selector += `[data-collapse-${this.dataset.collapseGroup}~=\"${value}\"]`;
        }

        this.collapseElements.forEach(el => {
            if (!selector) {
                el.classList.remove("d-none");
            }
            else {
                el.classList.toggle("d-none", !el.matches(selector));
            }
        });
    }

    get collapseElements() {
        return this.targetElement.querySelectorAll(`[data-collapse-${this.dataset.collapseGroup}]`);
    }

    get targetElement() {
        return this.dataset.target != null ? document.querySelector(this.dataset.target) : document;
    }

    get radioElements() {
        return this.querySelectorAll("input[type=radio]");
    }

}

customElements.define('radio-button-list-collapse', RadioButtonListCollapse, { extends: 'fieldset' });